import { useActiveTab } from './TabsContext'

const TabsContent = () => {
  const tab = useActiveTab()

  const { render } = tab || {}
  return !!render && render(tab)
}

export default TabsContent
